import { buttonBaseClasses, cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {
        card: {
            border: "none",
            background: "rgb(250, 250, 250)",
            [`.${simpleWidgetCardClasses.content}`]: {
                padding: "0 1em",
            },
        },
        header: {
            background: "#18468b",
            color: "#fff",
            padding: "13px 16px",
            [`> .${cardHeaderClasses.content}`]: {
                textTransform: "uppercase",
                [`.${typographyClasses.root}`]: {
                    ".MuiBox-root": {
                        [`.${typographyClasses.root}`]: {
                            fontSize: "1.2rem",
                            opacity: 1,
                        },
                    },
                },
            },
            [`> .${cardHeaderClasses.action}`]: {
                ".MuiBox-root": {
                    [`.${typographyClasses.root}`]: {
                        opacity: 1,
                    },
                    ".MuiBox-root": {
                        [`.${buttonBaseClasses.root}`]: {
                            color: "#fff",
                        },
                    },
                },
            },
        },
        actions: {
            padding: "0 1em 1em",
        },
    },
    variants: [
        {
            props: { widgetVariant: "dashboard" },
            style: {
                [`.${simpleWidgetCardClasses.card}, .${simpleWidgetCardClasses.cover}`]: {
                    border: "1px solid transparent",
                    background: "#f6f6f6",
                    "&:hover": {
                        borderColor: "#2e73db",
                    },
                },
            },
        },
    ],
})
